import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCitrixComponent } from './simple-icons-citrix.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCitrixComponent ],
    exports:      [ SimpleIconsCitrixComponent ],
    bootstrap:    []
})
export class SimpleIconsCitrixModule {}
